import { render, staticRenderFns } from "./PickupsSection.vue?vue&type=template&id=37c93f99"
import script from "./PickupsSection.vue?vue&type=script&lang=js"
export * from "./PickupsSection.vue?vue&type=script&lang=js"
import style0 from "./PickupsSection.vue?vue&type=style&index=0&id=37c93f99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports